(() => {
  if (window.pwAddonInfoReady) return;
  window.pwAddonInfoReady = true;
  const init = () => document.querySelectorAll('[data-pw-addon-dialog]').forEach(dialog => {
    if (dialog.dataset.pwAddonBound) return;
    const root = dialog.closest('edvi-product-detail');
    const checkbox = root?.querySelector('[data-evp-addon]');
    const button = dialog.querySelector('[data-pw-addon-select]');
    if (!checkbox || !button) return;
    dialog.dataset.pwAddonBound = 'true';
    const sync = () => {
      button.setAttribute('aria-pressed', String(checkbox.checked));
      button.textContent = checkbox.checked ? 'Added ✓' : 'Add';
      button.disabled = Boolean(root.busy || checkbox.disabled);
      dialog.querySelector('[data-pw-addon-status]').textContent = checkbox.checked ? 'Selected — included when you add your watch to cart.' : 'Included when you add your watch to cart.';
    };
    checkbox.addEventListener('change', sync);
    new MutationObserver(sync).observe(dialog, { attributes: true, attributeFilter: ['open'] });
    button.addEventListener('click', () => {
      if (root.busy || checkbox.disabled) return;
      checkbox.checked = !checkbox.checked;
      checkbox.dispatchEvent(new Event('change', { bubbles: true }));
    });
    new MutationObserver(sync).observe(root.querySelector('[data-evp-submit]'), { attributes: true, attributeFilter: ['disabled', 'aria-busy'] });
    dialog.addEventListener('keydown', event => {
      if (event.key !== 'Tab') return;
      const targets = [...dialog.querySelectorAll('a[href],button:not(:disabled),[tabindex="0"]')].filter(el => el.getClientRects().length);
      const first = targets[0], last = targets.at(-1);
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
    });
    const handle = dialog.querySelector('[data-pw-addon-drag]');
    let start;
    handle.addEventListener('pointerdown', event => {
      if (!matchMedia('(max-width:699px)').matches || event.target.closest('button,a') || event.button !== 0) return;
      start = { x: event.clientX, y: event.clientY, id: event.pointerId };
      handle.setPointerCapture(event.pointerId);
    });
    handle.addEventListener('pointerup', event => {
      if (!start || start.id !== event.pointerId) return;
      const close = event.clientY - start.y > 72 && Math.abs(event.clientX - start.x) < 60;
      start = null;
      if (close) dialog.close();
    });
    handle.addEventListener('pointercancel', () => { start = null; });
    sync();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();
